import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Sustainability @ CCSU</h1>
                <p>Home &gt; Sustainability @ CCSU</p>
            </div>
        </div>
    )
}

export default Hero;